const banks = [
    {
        card_no: 627381,
        bank_name: 'Ansar',
        bank_title: 'بانک انصار',
        bank_logo: '/banks/Ansar.svg',
        color: '#26eeb900',
    },
    {
        card_no: 636214,
        bank_name: 'Ayandeh',
        bank_title: 'بانک آینده',
        bank_logo: '/banks/Ayandeh.svg',
        color: '#3388391d',
    },
    {
        card_no: 502938,
        bank_name: 'Dey',
        bank_title: 'بانک دی',
        bank_logo: '/banks/Dey.svg',
        color: '#0dffffff',
    },
    {
        card_no: 627412,
        bank_name: 'Eghtesad_Novin',
        bank_title: 'بانک اقتصادنوین',
        bank_logo: '/banks/Eghtesad_Novin.svg',
        color: '#1a662891',
    },
    {
        card_no: 628157,
        bank_name: 'Tosee',
        bank_title: 'موسسه اعتباری توسعه',
        bank_logo: '/banks/Tosee.svg',
        color: '#33000000',
    },
    {
        card_no: 505416,
        bank_name: 'Gardeshgari',
        bank_title: 'بانک گردشگری',
        bank_logo: '/banks/Gardeshgari.svg',
        color: '#29344143',
    },
    {
        card_no: 639599,
        bank_name: 'Ghavamin',
        bank_title: 'بانک قوامین',
        bank_logo: '/banks/Ghavamin.svg',
        color: '#1afff400',
    },
    {
        card_no: 627488,
        bank_name: 'Karafarin',
        bank_title: 'بانک کارآفرین',
        bank_logo: '/banks/Karafarin.svg',
        color: '#333a881d',
    },
    {
        card_no: 502910,
        bank_name: 'Karafarin',
        bank_title: 'بانک کارآفرین',
        bank_logo: '/banks/Karafarin.svg',
        color: '#333a881d',
    },
    {
        card_no: 603770,
        bank_name: 'Keshavarzi',
        bank_title: 'بانک کشاورزی',
        bank_logo: '/banks/Keshavarzi.svg',
        color: '#29aa9a22',
    },
    {
        card_no: 639217,
        bank_name: 'Keshavarzi',
        bank_title: 'بانک کشاورزی',
        bank_logo: '/banks/Keshavarzi.svg',
        color: '#29aa9a22',
    },
    {
        card_no: 628023,
        bank_name: 'Maskan',
        bank_title: 'بانک مسکن',
        bank_logo: '/banks/Maskan.svg',
        color: '#1a000000',
    },
    {
        card_no: 639370,
        bank_name: 'Mehr_Eghtesad',
        bank_title: 'بانک مهر اقتصاد',
        bank_logo: '/banks/Mehr_Eghtesad.svg',
        color: '#1a656565',
    },
    {
        card_no: 606373,
        bank_name: 'Mehr_Iran',
        bank_title: 'بانک قرض الحسنه مهر ایرانیان',
        bank_logo: '/banks/Mehr_Iran.svg',
        color: '#1a209b1c',
    },
    {
        card_no: 603799,
        bank_name: 'Melli',
        bank_title: 'بانک ملی ایران',
        bank_logo: '/banks/Melli.svg',
        color: '#1a00e0d7',
    },
    {
        card_no: 610433,
        bank_name: 'Mellat',
        bank_title: 'بانک ملت',
        bank_logo: '/banks/Mellat.svg',
        color: '#1aba0b22',
    },
    {
        card_no: 991975,
        bank_name: 'Mellat',
        bank_title: 'بانک ملت',
        bank_logo: '/banks/Mellat.svg',
        color: '#1aba0b22',
    },
    {
        card_no: 622106,
        bank_name: 'Parsian',
        bank_title: 'بانک پارسیان',
        bank_logo: '/banks/Parsian.svg',
        color: '#29980000',
    },
    {
        card_no: 502229,
        bank_name: 'Pasargad',
        bank_title: 'بانک پاسارگاد',
        bank_logo: '/banks/Pasargad.svg',
        color: '#4d000000',
    },
    {
        card_no: 639347,
        bank_name: 'Pasargad',
        bank_title: 'بانک پاسارگاد',
        bank_logo: '/banks/Pasargad.svg',
        color: '#4d000000',
    },
    {
        card_no: 627760,
        bank_name: 'Postbank',
        bank_title: 'پست بانک ایران',
        bank_logo: '/banks/Postbank.svg',
        color: '#1a14763e',
    },
    {
        card_no: 589463,
        bank_name: 'Refah',
        bank_title: 'بانک رفاه',
        bank_logo: '/banks/Refah.svg',
        color: '#0d000000',
    },
    {
        card_no: 627961,
        bank_name: 'Sanat_Madan',
        bank_title: 'بانک صنعت و معدن',
        bank_logo: '/banks/Sanat_Madan.svg',
        color: '#339b814c',
    },
    {
        card_no: 603769,
        bank_name: 'Saderat',
        bank_title: 'بانک صادرات',
        bank_logo: '/banks/Saderat.svg',
        color: '#1a2d2a68',
    },
    {
        card_no: 621986,
        bank_name: 'Saman',
        bank_title: 'بانک سامان',
        bank_logo: '/banks/Saman.svg',
        color: '#1a7dcdf1',
    },
    {
        card_no: 639607,
        bank_name: 'Sarmayeh',
        bank_title: 'بانک سرمایه',
        bank_logo: '/banks/Sarmayeh.svg',
        color: '#29bd9ff5',
    },
    {
        card_no: 589210,
        bank_name: 'Sepah',
        bank_title: 'بانک سپه',
        bank_logo: '/banks/Sepah.svg',
        color: '#33ffc400',
    },
    {
        card_no: 504706,
        bank_name: 'Shahr',
        bank_title: 'بانک شهر',
        bank_logo: '/banks/Shahr.svg',
        color: '#29ffafb2',
    },
    {
        card_no: 502806,
        bank_name: 'Shahr',
        bank_title: 'بانک شهر',
        bank_logo: '/banks/Shahr.svg',
        color: '#29ffafb2',
    },
    {
        card_no: 639346,
        bank_name: 'Sina',
        bank_title: 'بانک سینا',
        bank_logo: '/banks/Sina.svg',
        color: '#1a277eb5',
    },
    {
        card_no: 627353,
        bank_name: 'Tejarat',
        bank_title: 'بانک تجارت',
        bank_logo: '/banks/Tejarat.svg',
        color: '#290fadc7',
    },
    {
        card_no: 585983,
        bank_name: 'Tejarat',
        bank_title: 'بانک تجارت',
        bank_logo: '/banks/Tejarat.svg',
        color: '#290fadc7',
    },
    {
        card_no: 636949,
        bank_name: 'Hekmat',
        bank_title: 'بانک حکمت',
        bank_logo: '/banks/Hekmat.svg',
        color: '#29563288',
    },
    {
        card_no: 627648,
        bank_name: 'Tosee_Saderat',
        bank_title: 'بانک توسعه صادرات',
        bank_logo: '/banks/Tosee_Saderat.svg',
        color: '#1f6d6900',
    },
    {
        card_no: 502908,
        bank_name: 'Tosee_Taavon',
        bank_title: 'بانک توسعه تعاون',
        bank_logo: '/banks/Tosee_Taavon.svg',
        color: '#290076ff',
    },
];

export const DEFAULT_BANK = {
    card_no: 111111,
    bank_name: 'Default',
    bank_title: 'نا مشخص',
    bank_logo: '/banks/Default.svg',
    color: '#26eeb900',
};

const banksNameByIban = {
    '010': 'Bank_Markazi',
    '011': 'Sanat_Madan',
    '012': 'Mellat',
    '013': 'Refah',
    '014': 'Maskan',
    '015': 'Sepah',
    '016': 'Keshavarzi',
    '017': 'Melli',
    '018': 'Tejarat',
    '019': 'Saderat',
    '020': 'Tosee',
    '021': 'Postbank',
    '022': 'Tosee_Taavon',
    '051': 'Mehr_Iran',
    '053': 'Karafarin',
    '054': 'Parsian',
    '055': 'Eghtesad_Novin',
    '056': 'Saman',
    '057': 'Pasargad',
    '058': 'Sarmayeh',
    '059': 'Sina',
    '060': 'Ghavamin',
    '061': 'Shahr',
    '062': 'Tat',
    '063': 'Ansar',
    '064': 'Gardeshgari',
    '065': 'Hekmat',
    '066': 'Noor',
    '069': 'Iran_Zamin',
};

export const _detectBank = (cardNumber: string) => {
    const onlyNum = (str: string) => str.replace(/[^.\d]/g, '');
    cardNumber = onlyNum(String(cardNumber));
    if (cardNumber.length < 6) return DEFAULT_BANK;
    const cardNumber_prefix = parseInt(cardNumber.substr(0, 6));
    const bank = banks.filter((b) => b.card_no === cardNumber_prefix);
    return bank.length === 0 ? DEFAULT_BANK : bank[0];
};

export const _detectBankByName = (name?: string) => {
    if (!name) return DEFAULT_BANK;
    const bank = banks.filter((b) => b.bank_title.includes(name));
    return bank.length === 0 ? DEFAULT_BANK : bank[0];
};

export const _formatCardNumber = (value: string) => {
    const cardValue = value.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
    if (cardValue) {
        const finalValue = !cardValue[2]
            ? cardValue[1]
            : `${cardValue[1]}-${cardValue[2]}${`${
                  cardValue[3] ? `-${cardValue[3]}` : ''
              }`}${`${cardValue[4] ? `-${cardValue[4]}` : ''}`}`;
        return finalValue;
    }
};
export const _detectBankByIBan = (iban: string) => {
    const cleanedIban = iban.trim(); // Trim whitespace
    if (cleanedIban.length >= 7) {
        const bankCode = cleanedIban.substring(4, 7);
        const bankName = banksNameByIban[bankCode as keyof typeof banksNameByIban];
        if (bankName) {
            return bankName; // Return the recognized bank name
        }
    }

    return;
};
